export const ReportsTemplates = {
  'app/components/reports/directives/report-value.html': require(
    './directives/report-value.html'
  ).default
};
